import { render, staticRenderFns } from "./UserSharedDrives.vue?vue&type=template&id=855977d4"
import script from "./UserSharedDrives.vue?vue&type=script&lang=js"
export * from "./UserSharedDrives.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports